module.exports = __webpack_public_path__ + "img/sbl0003.82a86c1f.png";